<div class="igntr-theme max-w-[1280px] mx-auto bg-[--background-color]">
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="p-7 space-y-5">
      <div class="flex items-start justify-between mb-4">
        <div class="flex items-start gap-2.5">
          <div
            class="w-8 h-8 rounded-lg bg-white border border-slate-200 flex items-center justify-center text-slate-700"
          >
            <igntr-icon name="bell"></igntr-icon>
          </div>
          <div>
            <div class="text-[14px] font-semibold text-slate-900">
              {{ "emailTemplates" | transloco }}
            </div>
          </div>
        </div>
        <button
          class="px-2.5 py-1.5 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium inline-flex items-center gap-1.5"
          type="submit"
        >
          {{ "save" | transloco }}
        </button>
      </div>
      <div
        class="rounded-xl border border-slate-200/70 bg-white grid grid-cols-1 md:grid-cols-2"
      >
        <div class="px-3.5 py-3">
          <div class="flex items-center justify-between mb-1">
            <span class="text-[14px] font-medium text-slate-700">
              {{ "Template" | transloco }}
            </span>
          </div>
          <div class="form-group form-floating mb-2">
            <textarea
              rows="10"
              class="w-full text-[14px] text-slate-800 bg-slate-50 border border-slate-200 rounded-md px-2.5 py-1.5 outline-none focus:border-slate-400 resize-none"
              formControlName="emailTemplate"
              autocomplete="off"
              type="text"
              placeholder="{{ 'text' | transloco }}"
            ></textarea>

            <div class="flex items-center justify-between mb-1">
              <span class="text-[14px] font-medium text-slate-700">
                {{ "Content" | transloco }}
              </span>
            </div>

            <p-editor
              [placeholder]="'footerText'"
              [style]="{ minHeight: '150px' }"
              formControlName="footerText"
            >
              <ng-template pTemplate="header">
                <app-editor
                  [allowImageInsert]="true"
                  [allowToolboxInsert]="true"
                  [allowOnboardingInsert]="true"
                  [allowSprintInsert]="true"
                  [isEmail]="true"
                ></app-editor>
              </ng-template>
            </p-editor>

            <div class="flex items-center justify-between mb-1">
              <span class="text-[14px] font-medium text-slate-700">
                {{ "backgroundColor" | transloco }}
              </span>
            </div>
            <div class="d-flex align-items-center">
              <p-colorpicker formControlName="backgroundColor"></p-colorpicker>
              <input
                type="text"
                formControlName="backgroundColor"
                class="form-control ms-2"
                [value]="form?.value.backgroundColor"
              />
            </div>
          </div>
        </div>

        <div
          class="bg-slate-50 border border-slate-200 rounded-md px-2.5 py-1.5 m-3 outline-none resize-none overflow-x-auto custom-scrollbar"
        >
          <div class="preview" [innerHTML]="previewHtml"></div>
        </div>
      </div>
    </div>
  </form>
</div>
